import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_top",
  "use": "arrow_top-usage",
  "viewBox": "0 0 10 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 13\" id=\"arrow_top\"><path d=\"M1.1 4.9a.4.4 0 0 0 0 .6c.175.17.466.17.641 0l3.283-3.07v10.15c.001.23.201.42.454.42.252 0 .46-.19.46-.42V2.43L9.215 5.5c.181.17.472.17.647 0a.4.4 0 0 0 0-.6l-4.06-3.81a.467.467 0 0 0-.641 0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol